class LoadMore {
    pageSize: number
    currentCount: number
    onLoadMore: () => void
    disabled: boolean

    loadMoreView: JQuery

    constructor(loadMoreView: JQuery) {
        this.loadMoreView = loadMoreView
        this.pageSize = loadMoreView.data('items-per-page')
        this.currentCount = loadMoreView.data('initial-item-count')
        loadMoreView.click(() => {
            if (this.disabled) return
            this.currentCount += this.pageSize
            this.onLoadMore()
            this.loadMoreView.addClass('loading')
        })
    }

    update(totalItems: number) {
        this.disabled = totalItems <= this.currentCount
        if (this.disabled) {
            this.loadMoreView.addClass('disabled')
        } else {
            this.loadMoreView.removeClass('disabled')
        }
    }

    onPostUpdate() {
        this.loadMoreView.removeClass('loading')
    }
}

export default LoadMore